import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { PlusIcon, ArrowDownTrayIcon, ArrowUpTrayIcon } from "@heroicons/vue/24/solid";
// import { IonButton } from '@ionic/vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonComponent',
  props: {
    type: {
        type: String,
        default: 'button'
    },
    color: {
        type: String,
        default: 'bg-primary-500'
    },
    expand: {
        type: String,
        default: null // block, full
    },
    fill: {
        type: String,
        default: 'solid' // clear, outline, solid
    },
    size: {
        type: String,
        default: 'large' // small, default, large
    },
    disabled: {
        type: Boolean,
        default: false
    },
    secondary: {
        type: Boolean,
        default: false
    },
    customClass: {
        type: String,
        default: null
    },

    createBtn: {
        type: Boolean,
        default: false
    },
    exportBtn: {
        type: Boolean,
        default: false
    },
    importBtn: {
        type: Boolean,
        default: false
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: __props.disabled,
    class: _normalizeClass(["inline-flex items-center justify-center p-3 border border-solid rounded-lg text-sm transition h-11", [
            __props.color,
            __props.secondary
                ? 'bg-white border-gray-300 text-gray-500 hover:text-primary-600 focus:outline-none active:text-gray-800 active:bg-gray-50 disabled:opacity-25 '
                : 'border-primary-500 disabled:opacity-25 text-white focus:ring-1 focus:ring-offset-1'
        ]])
  }, [
    (__props.createBtn)
      ? (_openBlock(), _createBlock(_unref(PlusIcon), {
          key: 0,
          class: "w-5 h-5 mr-2"
        }))
      : (__props.exportBtn)
        ? (_openBlock(), _createBlock(_unref(ArrowDownTrayIcon), {
            key: 1,
            class: "w-5 h-5 mr-2"
          }))
        : (__props.importBtn)
          ? (_openBlock(), _createBlock(_unref(ArrowUpTrayIcon), {
              key: 2,
              class: "w-5 h-5 mr-2"
            }))
          : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})